import { Box, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import ParentMenuItem from "./ParentMenuItem";

const ParentSelector = ({ data, placeholders, handleParentChange }) => {
  const { t } = useTranslation();

  return (
    <Box my={1} id="parent">
      <InputLabel shrink>{t("/editor.gui.parent")}</InputLabel>
      <Select
        size="small"
        sx={{ maxWidth: 300 }}
        value={data?.parentId ?? "none"}
        onChange={handleParentChange}
        renderValue={(value) =>
          value === "none" ? (
            <MenuItem value="none">{t("/editor.gui.none")}</MenuItem>
          ) : (
            <ParentMenuItem p={data} value={value} />
          )
        }
      >
        <MenuItem value="none">{t("/editor.gui.none")}</MenuItem>
        {placeholders
          ?.filter((p) => !p?.parentId && p?.id !== data?.id)
          .map((p) => (
            <ParentMenuItem key={p.id} value={p.id} p={p} />
          ))}
      </Select>
    </Box>
  );
};

export default ParentSelector; 